import {
  HostListener,
  Component,
  inject,
  Input,
  OnInit,
  OnDestroy
} from '@angular/core';
import { PaymentFormComponent } from 'src/app/pages/form/booking-handler/payment-form/payment-form.component';
import { DataForm } from 'src/app/models/data.model';
import { TranslatePipe } from '@ngx-translate/core';
import { HOBEX, PAYMENT_WITH_WEBHOOKS } from 'src/app/app.constants';
import { logger } from 'src/app/utils';
import { CircularProgressBarComponent } from '@progress/kendo-angular-progressbar';
import { environment } from 'src/environments/environment';
import { PaymentService } from 'src/app/services/payment.service';
import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { Icons } from 'src/app/icons';
import { PriceStateComponent } from 'src/app/pages/form/price-state/price-state.component';
import { SpacerComponent } from 'src/app/ui/atoms/spacer/spacer.component';
import { UrlService } from 'src/app/services/url.service';

@Component({
    selector: 'app-online-payment',
    imports: [
        PaymentFormComponent,
        TranslatePipe,
        CircularProgressBarComponent,
        SVGIconComponent,
        PriceStateComponent,
        SpacerComponent
    ],
    templateUrl: './online-payment.component.html',
    styleUrl: './online-payment.component.scss'
})
export class OnlinePaymentComponent implements OnInit, OnDestroy {
  protected readonly icons = Icons;

  private readonly succeedCode: string;

  private urlService = inject(UrlService);
  private paymentService = inject(PaymentService);

  @Input() data: DataForm;
  @Input() contractId?: string;
  @Input({required: true}) params: any;

  ndc?: string;
  checkoutId?: string;

  hidePriceState = false;
  placeOrderError?: any | undefined;

  constructor() {
    this.succeedCode = environment.production
      ? HOBEX.TRANSACTION_SUCCEEDED
      : HOBEX.TEST_TRANSACTION_SUCCEEDED;
  }

  ngOnInit() {
    if (this.data && !this.contractId) {
      this.placeOrder();
    } else if (!this.data && this.contractId) {
      this.retryOrder();
    }
  }

  private retryOrder() {
    this.paymentService.retryCheckout(this.contractId!).subscribe({
      next: (response: any) => {
        if (response?.orderInfo?.result?.code === HOBEX.SUCCESSFULLY_CREATED_CHECKOUT) {
          this.contractId = response.orderContractId;
          this.checkoutId = response.orderInfo.id;
          this.ndc = response.orderInfo.ndc;
        }
      },
      error: (error: any) => this.placeOrderError = error,
    });
  }

  private placeOrder() {
    this.paymentService.placeOrder(this.data).subscribe({
      next: (response: any) => {
        logger.i('placeOrder response', response);
        if (response?.orderInfo?.result?.code === HOBEX.SUCCESSFULLY_CREATED_CHECKOUT) {
          this.contractId = response.orderContractId;
          this.ndc = response.orderInfo.ndc;
          this.checkoutId = response.orderInfo.id;
        } else {
          this.placeOrderError = response?.orderInfo.result;
        }
      },
      error: (error: any) => this.placeOrderError = error,
    });
  }

  @HostListener('window:message', ['$event'])
  onMessage(e: any) {
    const expectedOrigin = environment.domainUrl.replace(/\/$/, '');
    if (e.origin !== expectedOrigin) return;
    if (e.data && e.data.type) {
      if (e.data.type === 'hobexAction') {
        if (e.data.action === 'close') {
          const targetUrlBase = this.urlService.getApplicationBaseUrl();
          const queryParams = new URLSearchParams(this.params).toString();
          let finalUrl = targetUrlBase;
          if (environment.production) {
            if (queryParams.length > 0) finalUrl += '#/?' + queryParams;
          } else {
            if (queryParams.length > 0) finalUrl += '?' + queryParams;
          }
          window.location.href = finalUrl;
          window.location.reload();
        } else if (e.data.action === 'retry') {
          this.unloadHobexWidget();
          this.ndc = undefined;
          this.checkoutId = undefined;
          this.retryOrder();
        }
      } else if (e.data.type === 'hobexError') {
      //  logger.w(e.data.type?.error);
      } else if (e.data.type === 'hobexResponse' && e.data.data) {
        logger.i('data has hobex response');
        const successCondition = PAYMENT_WITH_WEBHOOKS
          ? (e.data.data?.resultCode === this.succeedCode)
          : (e.data.data?.status === 200);
        if (successCondition) {
          logger.i('hide back button');
          this.hidePriceState = true;
        }
      }
    }

  }

  private unloadHobexWidget() {
    const wpwl = (window as any).wpwl;
    logger.i('start unloading hobex widget', wpwl);
    if (wpwl && wpwl.unload !== undefined) wpwl.unload();
    document.querySelectorAll('script').forEach(script => {
      if (script.src.indexOf('static.min.js') !== -1) {
        logger.i('removing hobex script', script);
        script.remove();
      }
    });
    logger.i('unloading hobex widget completed');
  }

  ngOnDestroy() {
    this.unloadHobexWidget();
  }

}
